import { FiMail } from 'react-icons/fi';

const MessageDetailPanel = ({ selectedMessage, onUpdateStatus, onDelete }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-5 h-fit sticky top-4">
    {selectedMessage ? (
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-sm font-bold text-orange-600">
            {selectedMessage.name?.charAt(0).toUpperCase()}
          </span>
          <div>
            <p className="font-semibold text-black">{selectedMessage.name}</p>
            <p className="text-xs text-black">{selectedMessage.email}</p>
          </div>
        </div>

        {selectedMessage.phone && (
          <p className="text-sm text-black">📱 {selectedMessage.phone}</p>
        )}

        <div className="border-t pt-3">
          <p className="text-sm font-semibold text-black mb-2">
            {selectedMessage.subject || 'No subject'}
          </p>
          <p className="text-sm text-black whitespace-pre-wrap leading-relaxed">
            {selectedMessage.message}
          </p>
        </div>

        <p className="text-xs text-black border-t pt-3">
          Received: {new Date(selectedMessage.createdAt).toLocaleString()}
        </p>

        <div className="flex gap-2 pt-2">
          <button
            onClick={() => onUpdateStatus(selectedMessage.id, 'read')}
            className="px-3 py-1.5 text-xs bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 font-medium"
          >
            Mark Read
          </button>
          <button
            onClick={() => onUpdateStatus(selectedMessage.id, 'replied')}
            className="px-3 py-1.5 text-xs bg-green-50 text-green-700 rounded-lg hover:bg-green-100 font-medium"
          >
            Mark Replied
          </button>
          <button
            onClick={() => onDelete(selectedMessage.id)}
            className="px-3 py-1.5 text-xs bg-red-50 text-red-700 rounded-lg hover:bg-red-100 font-medium"
          >
            Delete
          </button>
        </div>
      </div>
    ) : (
      <div className="text-center py-12">
        <FiMail size={36} className="text-black mx-auto mb-3" />
        <p className="text-sm text-black">Select a message to view details</p>
      </div>
    )}
  </div>
);

export default MessageDetailPanel;
